import { createSelector } from 'reselect';
import { getEntities } from './utils';

const getProfile = createSelector(getEntities, entities => entities.profile);

export {
  getProfile
};
